import { mobileApiRequest } from '../utils/request/applicationRequests';

export type ActivityAnswer = {
  query: string;
  id: string;
  activity: string;
  activityId: string;
  group: string;
  groupId: string;
};

export const apiActivitySearch = async (query: string): Promise<ActivityAnswer[]> => {
  const res = await mobileApiRequest.post('/activities/search-v2', {
    q: query,
    type: 'activity',
  });
  return (res.hits.hits as any).map(
    ({ _id, _source: { Activity, ActivityId, Group, GroupId } }: any) => ({
      id: _id,
      activity: Activity,
      activityId: ActivityId,
      group: Group,
      groupId: GroupId,
      query,
    })
  );
};
